var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"data-cy":_vm.dataCy},on:{"click":_vm.onClick}},[(_vm.imgPath)?_c('div',{staticClass:"avatar-image",class:_vm.avatarClasses,style:(_vm.bgImage)}):_c('span',{staticClass:"avatar-letters",class:_vm.avatarClasses},[_vm._v(" "+_vm._s(_vm.userNameFirstLatter)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }